import { AnswerType } from '../../shared/enums/answer.enum';
import { Answer } from './answer.model';

export type ScaleQuestionAnswer = number;

// Without this dynamic parameter AOT compiling will fail.
// @see https://angular.io/guide/angular-compiler-options#strictmetadataemit
// @dynamic
export class ScaleAnswer extends Answer {
  public answer: ScaleQuestionAnswer | undefined;

  constructor(id: string, type: AnswerType, answer?: ScaleQuestionAnswer) {
    super();
    this.id = id;
    this.type = type;
    this.answer = answer;
  }

  public static fromDto(dto: any): ScaleAnswer {
    return new ScaleAnswer(dto.id, dto.type, dto.answer);
  }
}
